import {
    createHandlerChainRunner,
    HasOnComplete,
} from "@insite/client-framework/HandlerCreator";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { getWarehouse } from "@WhiteCap/Services/GetWarehouseService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<
    {
        warehouseId: string;
        changeShipWarehouse: boolean;
    },
    WarehouseModel
> &
    HasOnComplete;

export const DispatchBeginWarehouseData: HandlerType = props => {
    props.dispatch({
        type: "Custom/Warehouse/BeginLoadWarehouse",
    });
    // To store warehouse data(by Id) in custom application state -> warehouses
    props.dispatch({
        type: "Custom/Warehouses/BeginLoadData",
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getWarehouse(props.apiParameter.warehouseId);
    } catch (error) {
        props.dispatch({
            type: "Custom/Warehouses/CompleteLoadData",
            message: error || "Something went wrong!",
        });
    }
};
export const DispatchCompleteWarehouseData: HandlerType = props => {
    if (!props.apiResult) {
        props.dispatch({
            type: "Custom/Warehouse/LoadWarehouseError",
        });
        return;
    }
    if (props.apiParameter.changeShipWarehouse) {
        props.dispatch({
            type: "Custom/Warehouse/CompletedLoadWarehouse",
            result: props.apiResult,
        });
    }

    // To store warehouse data(by Id) in custom application state -> warehouses
    props.dispatch({
        type: "Custom/Warehouses/CompleteLoadData",
        result: props.apiResult,
        warehouseId: props.apiParameter.warehouseId,
    });
};

export const chain = [
    DispatchBeginWarehouseData,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteWarehouseData,
    // DispatchCompleteWarehouseDatasession,
];

const loadWarehouse = createHandlerChainRunner(chain, "LoadWarehouse");
export default loadWarehouse;
